// tr strings for messages/nav.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const nav: Dict = {
  "nav.home": "Ana sayfa",
  "nav.create": "Oluştur",
  "nav.voices": "Sesler",
  "nav.train": "Ses eğit",
  "nav.library": "Kütüphane",
  "nav.tab.profile": "Profil",
  "nav.pricing": "Fiyatlar",
  "nav.affiliate": "Ortaklık Programı",
  "nav.api": "API",
  "nav.login": "Giriş yap",
  "nav.signup": "Kaydol",
  "nav.signupFree": "Ücretsiz kaydol",
  "nav.getPlan": "Plan seç",
  "nav.discordAria": "Jammable Discord'una katıl",
  "nav.discordJoin": "Discord'umuza katıl",
  "nav.openMenu": "Menüyü aç",
  "nav.closeMenu": "Menüyü kapat",

  "nav.greet.0.0": "Erkencisin!",
  "nav.greet.0.1": "Günaydın",
  "nav.greet.0.2": "N'aber",
  "nav.greet.0.3": "Selam",
  "nav.greet.0.4": "Naber?",
  "nav.greet.1.0": "Hey",
  "nav.greet.1.1": "Selam",
  "nav.greet.1.2": "Merhaba",
  "nav.greet.1.3": "Nasıl gidiyor?",
  "nav.greet.1.4": "İyi günler",
  "nav.greet.2.0": "İyi akşamlar",
  "nav.greet.2.1": "Selam sana",
  "nav.greet.2.2": "Neler oluyor?",
  "nav.greet.2.3": "Merhaba",
  "nav.greet.2.4": "Selamlar",
  "nav.greet.3.0": "Hâlâ uyanık mısın?",
  "nav.greet.3.1": "Gece kuşu, ha?",
  "nav.greet.3.2": "Selam, gece insanı",
  "nav.greet.3.3": "Uyuyamadın mı?",
  "nav.greet.3.4": "Gece yarısı modu",
  "nav.profile.view": "Profili gör",
  "nav.profile.credit": "Kredi",
  "nav.profile.credits": "Kredi",
  "nav.profile.voicePass": "Ses Hakkı",
  "nav.profile.voices": "Ses Hakkı",
  "nav.profile.shop": "Mağaza",
  "nav.profile.feedback": "Geri bildirim gönder",
  "nav.profile.settings": "Ayarlar",
  "nav.profile.apiDashboard": "API Paneli",
  "nav.profile.signOut": "Çıkış yap",
  "nav.profile.signedOut": "Çıkış yapıldı!",
  "nav.profile.avatarAlt": "kullanıcı avatarı",

  "nav.footer.tagline":
    "100.000+ sesle AI cover. Saniyeler içinde bir tane yap.",
  "nav.footer.colCreate": "Oluştur",
  "nav.footer.colAccount": "Hesap",
  "nav.footer.colLegal": "Yasal",
  "nav.footer.aiCover": "AI Cover Oluşturucu",
  "nav.footer.voiceChanger": "Yapay Zeka Ses Değiştirici",
  "nav.footer.voiceLibrary": "Yapay Zeka Ses Kütüphanesi",
  "nav.footer.train": "Ses Eğit",
  "nav.footer.weights": "Weights.gg Alternatifi",
  "nav.footer.settings": "Ayarlar",
  "nav.footer.earn": "Jammable ile Kazan",
  "nav.footer.mcp": "Yapay Zeka Ajanları için MCP Sunucusu",
  "nav.footer.forgot": "Şifremi unuttum",
  "nav.footer.terms": "Kullanım Koşulları",
  "nav.footer.privacy": "Gizlilik Politikası",
  "nav.footer.dmca": "DMCA Politikası",
  "nav.footer.refunds": "İade Politikası",
  "nav.footer.pitchmeldBefore": "Ses işleme için",
  "nav.footer.pitchmeldLink": "Pitchmeld teknolojisi",
  "nav.footer.pitchmeldAfter": "kullanılır",

  "nav.language": "Dil",
};

export default nav;
